import { FetchWithAuth } from '../types';
import { API_URL } from '../utils';

export const getCategories = (fetchWithAuth: FetchWithAuth) =>
  fetchWithAuth(`${API_URL}/exercises/categories`).then(res => res.json());

export const createCategory = (fetchWithAuth: FetchWithAuth, data: { name: string }) =>
  fetchWithAuth(`${API_URL}/exercises/categories`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(res => res.json());

export const updateCategory = (fetchWithAuth: FetchWithAuth, id: number, data: { name: string }) =>
  fetchWithAuth(`${API_URL}/exercises/categories/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(res => res.json());

export const deleteCategory = (fetchWithAuth: FetchWithAuth, id: number) =>
  fetchWithAuth(`${API_URL}/exercises/categories/${id}`, {
    method: 'DELETE',
  });
